import React from 'react';

function AboutTeaser({ navigateTo }) {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-indigo-600 tracking-wide uppercase">Who We Are</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Innovation. Expertise. Partnership.
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            KSL combines deep technical expertise with a creative, problem-solving mindset to craft tailored IT and AI strategies designed to streamline operations, enhance decision-making, and fuel sustainable growth.
          </p>
          <div className="mt-8">
            <button onClick={() => navigateTo('about')} className="text-base font-medium text-indigo-600 hover:text-indigo-500">
              Learn more about us <span aria-hidden="true">&rarr;</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutTeaser; 